import { ConfigsManager } from './../config/configs';
// Configs
var SMOOTHING = 0.1;
var FFT_SIZE = 512;
// dB values for thresholds
var THRESHOLD_LOW = -70;
var THRESHOLD_HIGH = -27;
var RTCTrack = /** @class */ (function () {
    function RTCTrack(stream, _audioCtx, voice_levels) {
        if (voice_levels === void 0) { voice_levels = ConfigsManager.VOICE_ACTIVITY_LEVELS; }
        this.stream = stream;
        this._audioCtx = _audioCtx;
        this.voice_levels = voice_levels;
        this._buffer = new Array(5);
        // Fast Fourier Transform bins (fftBins)
        this._fftBins = new Float32Array(FFT_SIZE);
        this._volume = 0;
        this._analyser = null;
        this._sourceNode = null;
        // Stream to be analyzed
        this.video = !!stream.getVideoTracks().length;
        this.audio = !!stream.getAudioTracks().length;
        this._volume = 0;
        // Populate buffer with blank values
        this._buffer.fill(0);
    }
    RTCTrack.prototype.mute = function () {
        this.stream.getAudioTracks()[0].enabled = false;
    };
    RTCTrack.prototype.unmute = function () {
        this.stream.getAudioTracks()[0].enabled = true;
    };
    RTCTrack.prototype.createAnalyzer = function () {
        this._validateAudioContext();
        this._analyser = this._audioCtx.createAnalyser();
        this._analyser.fftSize = FFT_SIZE;
        this._analyser.smoothingTimeConstant = SMOOTHING;
        var audioStream = new MediaStream(this.stream.getAudioTracks());
        this._sourceNode = this._audioCtx.createMediaStreamSource(audioStream);
        this._sourceNode.connect(this._analyser);
    };
    RTCTrack.prototype.closeAnalyzer = function () {
        if (this._sourceNode) {
            this._sourceNode.disconnect();
            this._sourceNode = null;
        }
        if (this._analyser) {
            this._analyser.disconnect();
            this._analyser = null;
        }
    };
    RTCTrack.prototype.analyzeTrack = function () {
        this._validateAudioContext();
        var trackVolume = this.volume;
        var audioLevel = this._getAudioLevel();
        if (this.volume !== audioLevel) {
            // History is the sum of the audio levels that were greater than 0
            var history_1 = 0;
            for (var i = 0; i < this._buffer.length; i++) {
                history_1 += this._buffer[i];
            }
            if (history_1 >= 3) {
                // If we have detected audio in at least 3 of the last 5 intervals then adjust it gradually
                var modifier = this.volume > audioLevel ? -1 : 1;
                this._volume = this.volume + modifier;
                trackVolume = this.volume;
            }
            else if (audioLevel === 0) {
                // If audio is detected only in 2 out of the last 5 intervals and is 0 for the 3rd time then adjust to the audioLevel
                this._volume = audioLevel;
                trackVolume = this.volume;
            }
        }
        this._buffer.shift();
        this._buffer.push(audioLevel === 0 ? 0 : 1);
        return trackVolume;
    };
    RTCTrack.prototype._validateAudioContext = function () {
        if (this._audioCtx.state === 'suspended') {
            this._audioCtx.resume();
        }
    };
    RTCTrack.prototype._getAudioLevel = function () {
        var volume = this._getMaxVolume();
        // Find in which volume bucket we're in
        if (volume < THRESHOLD_LOW) {
            return 0;
        }
        else if (volume > THRESHOLD_HIGH) {
            return this.voice_levels;
        }
        else {
            return Math.ceil((volume - THRESHOLD_LOW) / (THRESHOLD_HIGH - THRESHOLD_LOW) * this.voice_levels);
        }
    };
    RTCTrack.prototype._getMaxVolume = function () {
        var maxVolume = -Infinity;
        if (this._analyser) {
            this._analyser.getFloatFrequencyData(this._fftBins);
        }
        for (var i = 4, ii = this._fftBins.length; i < ii; i++) {
            if (this._fftBins[i] > maxVolume && this._fftBins[i] < 0) {
                maxVolume = this._fftBins[i];
            }
        }
        return maxVolume;
    };
    Object.defineProperty(RTCTrack.prototype, "id", {
        get: function () {
            return this.stream.id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RTCTrack.prototype, "volume", {
        get: function () {
            return this._volume;
        },
        enumerable: true,
        configurable: true
    });
    RTCTrack.prototype.close = function () {
        this.closeAnalyzer();
    };
    return RTCTrack;
}());
export { RTCTrack };
export default RTCTrack;
//# sourceMappingURL=RTCTrack.js.map